<template>
  <v-card>
      <v-card-title>
        <div class="headline">Nature of Loss Listing</div>
        <v-spacer></v-spacer>
        <v-flex xs6>
          <v-autocomplete :items="clmNol1List" v-model="filters.search" :label="filtersLabel.nol1" item-text="label" item-value="value" clearable></v-autocomplete>
        </v-flex>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="filters.search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.nol1ShortDesc }}</td>
          <td class="text-xs-left">{{ props.item.giaType }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click.native="doNew()">New Nature of Loss<v-icon>mdi-plus</v-icon></v-btn>
      <v-dialog v-model="clmNol1Dialog" max-width="600px" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Permit Nature of Loss for Business Class</span>
          </v-card-title>
          <v-card-text>
            <message :messages="messages"></message>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs6 v-if="!newBusClsClmNol1">
                  <v-subheader class="queryLabel">{{labels.nol1Query}}</v-subheader>
                  <div class="title">{{clmNol1Form.nol1}}</div>
                </v-flex>
                <v-flex xs6 v-else>
                  <v-autocomplete :label="labels.nol1" v-model="clmNol1Form.nol1" :items="clmNol1List" item-text="label" item-value="value" :error-messages="errors.first('busCls') ? errors.first('busCls') :errors.collect('nol1')" data-vv-name="nol1" :data-vv-as="labels.nol1" v-validate="'required'" :loading="clmNol1Loading"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-text-field v-model="clmNol1Form.giaType" :label="labels.giaType" :error-messages="errors.collect('giaType')" v-validate="'entry|max:2'" data-vv-name="giaType" :data-vv-as="labels.giaType"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
            <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Permitted Business Class?
      <div class="title">{{deleteBusClsClmNol1}}</div>
      </confirm>
    </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import FieldMixin from '@/mixins/field'
import { extractMenu } from '@/utils/extract'
export default {
  data() {
    return {
      headers: [
        { text: 'Nature of Loss', value: 'nol1ShortDesc' },
        { text: 'GIA Type', value: 'giaType' },
        TableConst.tableActionHeader
      ],
      filtersLabel: {
        nol1: 'Nature of Loss',
        giaType: 'GIA Type'
      },
      filters: {
        giaType: null
      },
      labels: {
        nol1Query: 'Nature of Loss',
        nol1: 'Nature of Loss*',
        giaType: 'GIA Type'
      },
      clmNol1Form: {
        nol1: null,
        busCls: null,
        giaType: null
      },
      loading: null,
      newBusCls: false,
      clmNol1List: [],
      clmNol1Dialog: false,
      clmNol1Loading: false,
      newBusClsClmNol1: false,
      menu: [],
      deleteBusClsClmNol1: '',
      promptRemove: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    appID() {
      return this.$store.state.parameters.appID
    },
    busClsMenu() {
      return this.$store.state.parameters.busCls.busClsMenu.menu
    }
  },
  methods: {
    async doInit() {
      if (!this.newBusCls) {
        // Review
        await this.fetchData(this.id)
      }
      await this.clmNol1ListInit()
    },
    async fetchData(xbuscls) {
      this.loading = true
      const apiURI = this.busClsMenu.busClsClmNol1s
      let expand = {
        busCls: xbuscls
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        if (result.data) {
          this.totalItems = result.data.totalElements
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((busClsClmNol1) => {
              const convertBusClsClmNol1 = {
                nol1: busClsClmNol1.nol1,
                busCls: busClsClmNol1.busCls,
                nol1ShortDesc: busClsClmNol1.nol1 + ' - ' + busClsClmNol1.nol1ShortDesc,
                giaType: busClsClmNol1.giaType
              }
              this.items.push(convertBusClsClmNol1)
            })
          } else {
            this.items = []
          }
        }
        this.loading = false
      }
    },
    doClearFilters() {
      this.filters.nol1 = null
      this.filters.busCls = null
      this.filters.giaType = null
      this.fetchData(this.id)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(this.id)
        }
      })
    },
    doNew() {
      this.resetMessages()
      this.clmNol1Form.nol1 = null
      this.clmNol1Form.busCls = this.id
      this.clmNol1Form.giaType = null
      this.clmNol1Dialog = true
      this.newBusClsClmNol1 = true
    },
    async doReview(item) {
      this.newBusClsClmNol1 = false
      const apiURI = this.busClsMenu.busClsClmNol1
      if (apiURI) {
        try {
          const expand = {
            appID: this.appID,
            nol1: item.item.nol1,
            busCls: item.item.busCls
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.clmNol1Form.nol1 = data.busClsClmNol1.nol1
            this.clmNol1Form.busCls = data.busClsClmNol1.busCls
            this.clmNol1Form.giaType = data.busClsClmNol1.giaType
            this.clmNol1Dialog = true
            this.menu = extractMenu(result.data._links)
          } else {
            this.$snotify.error('Invalid API URL - Business Class Nature of Loss Review')
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Business Class Nature of Loss Review')
      }
    },
    async clmNol1ListInit() {
      const apiURI = this.busClsMenu.clmNol1List
      if (apiURI) {
        try {
          const expand = {
            appId: this.appID
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.clmNol1List = data
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL - Business Class Nature of Loss List')
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newBusClsClmNol1) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.busClsMenu.busClsClmNol1Update
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.clmNol1Form)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            await this.fetchData(this.clmNol1Form.busCls)
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Business Class Nature of Loss Update')
      }
    },
    async doCreate() {
      const apiURI = this.busClsMenu.busClsClmNol1Create
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.clmNol1Form)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            await this.fetchData(this.clmNol1Form.busCls)
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Business Class Nature of Loss Create')
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedBusClsClmNol1 = data
        this.deleteBusClsClmNol1 = data.nol1ShortDesc
      }
    },
    async doRemove() {
      const apiURI = this.busClsMenu.busClsClmNol1Delete
      if (apiURI) {
        this.loading = true
        const expand = {
          nol1: this.selectedBusClsClmNol1.nol1,
          busCls: this.id
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.doInit()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Business Class Nature of Loss')
      }
    },
    doClose() {
      this.resetMessages()
      this.clmNol1Form.nol1 = undefined
      this.clmNol1Form.giaType = undefined
      this.clmNol1Dialog = false
    }
  },
  mounted() {
    if (this.busCls === 'new') {
      this.newBusCls = true
    } else {
      this.doInit()
    }
  },
  created() {

  },
  props: ['id'],
  mixins: [
    TableConst.default,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
